export const COMPANY_READONLY = [
  ["Domain_Name", "Business Type"],
  ["Status", "Status"],
];

export const COMPANY_DETAILS_READONLY = [
  ["Company_Name", "Company Name"],
  ["Company_Email", "Company Email"],
  ["Company_Phone", "Company Phone"],
];

export const COMPANY_EDITABLE = [
  ["Website", "Website"],
  ["Website_Domain_Name", "Website Domain Name"],
];

export const COMPANY_ADDRESS_EDITABLE = [
  ["Address_Line_1", "Address Line 1"],
  ["Address_Line_2", "Address Line 2"],
  ["Zip_Code", "Zip Code"],
];

export const COMPANY_ADDRESS = [
  ...COMPANY_ADDRESS_EDITABLE.slice(0, 2),
  ["Country_Name", "Country"],
  ["State_Name", "State"],
  ["City_Name", "City"],
  ...COMPANY_ADDRESS_EDITABLE.slice(2),
];

export function displayCompanyValue(value) {
  if (value == null || String(value).trim() === "") return "—";
  return String(value);
}
